export const DRAGGABLE_TYPE = 'assembly-tree-node'
